export default __webpack_public_path__ + "static/media/landlord_2.5ed27582.png";